import { Button, Modal } from 'primsell-shared-layer/components'

import { useBurnNftModalController } from './burn-nft-modal.controller'

import * as S from './burn-nfr-modal.styles'

import { IBurnNftModalProps } from './burn-nft-modal.types'

const BurnNftModal = ({ handleBurn }: IBurnNftModalProps) => {
  const {
    isLoading,
    amountToRedeem,
    maxAmount,
    handleCloseModal,
    handleChangeAmount,
    handleAdd,
    handleSubtract,
    handleMax,
    handleCancel,
  } = useBurnNftModalController()

  return (
    <Modal onClose={handleCloseModal}>
      <Modal.Header
        title={
          <>
            Burn this NFT? <S.FireIcon />
          </>
        }
      />
      <Modal.Content>
        <S.DescriptionContainer>
          <S.DescriptionTypography>
            To receive a unique code for obtaining your product, please proceed with burning your NFT. This action
            cannot be undone
          </S.DescriptionTypography>
        </S.DescriptionContainer>
        <S.FormContainer>
          <S.FormInput
            name="quantity"
            value={amountToRedeem}
            onChange={handleChangeAmount}
            label="Enter quantity"
            isRequired
            placeholder="0"
            startAdornment={
              <div
                style={{
                  display: 'flex',
                  height: '100%',
                  alignItems: 'center',
                  marginLeft: '16px',
                  color: `${amountToRedeem <= 1 ? 'lightgrey' : ''}`,
                  cursor: 'pointer',
                }}
                onClick={() => {
                  if (amountToRedeem <= 1) {
                    return
                  }
                  handleSubtract()
                }}
              >
                -
              </div>
            }
            endAdornment={
              <div
                style={{
                  display: 'flex',
                  height: '100%',
                  alignItems: 'center',
                  marginRight: '16px',
                  color: `${amountToRedeem >= +maxAmount ? 'lightgrey' : ''}`,
                  cursor: 'pointer',
                }}
                onClick={() => {
                  if (amountToRedeem >= +maxAmount) {
                    return
                  }
                  handleAdd()
                }}
              >
                +
              </div>
            }
          />
          <S.FlyText onClick={handleMax}>MAX</S.FlyText>
        </S.FormContainer>
      </Modal.Content>

      <Modal.Footer>
        <div style={{ display: 'flex', gap: '8px' }}>
          <Button onClick={handleCancel} color="grey" variant="outlined">
            No, cancel
          </Button>
          <Button
            onClick={handleBurn}
            disabled={!amountToRedeem || amountToRedeem > +maxAmount}
            color="dark"
            variant="filled"
            isLoading={isLoading}
          >
            Burn NFT
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export { BurnNftModal }
